import React, { useContext, useEffect, useRef, useState } from 'react';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonButtons, IonMenuButton, IonGrid, IonRow, IonCol, IonBackButton, IonButton, IonIcon, IonList, IonItem, IonLabel, IonInput, IonTextarea, IonToggle, IonCheckbox, IonLoading, IonRefresher, IonRefresherContent, IonToast, IonRouterContext, IonCard, IonDatetime, IonCardHeader, IonCardContent, IonModal, IonSelect, IonSelectOption, IonAlert, IonItemDivider, useIonViewWillEnter, useIonViewDidEnter, useIonViewWillLeave, useIonViewDidLeave } from '@ionic/react';

import { connect } from '../../data/connect';
import './CashflowReport.scss';
import API from '../../services';
import { RouteComponentProps, RouteProps, withRouter } from 'react-router';
import { add, arrowRedo, cartOutline, cash, closeCircle, eyeOutline, grid, informationCircleOutline, list, newspaperOutline, pencil, printOutline, remove, save as saveicon, saveOutline, search, send, trashBin } from 'ionicons/icons';
import Form from '../../components/ActiveForm/Form';
import { getOptionsdata, getTemplate } from '../../data/form/template';
import Selectfield from '../../components/ActiveForm/Selectfield';
import SearchItemForm from '../Stockopname/SearchItemForm';
import NumberFormat from 'react-number-format';
import SearchPartnerForm from '../Partner/SearchPartnerForm';
import ViewPartnerForm from '../Partner/ViewPartnerForm';
import AddPartnerForm from '../Partner/AddPartnerForm';
import EditPartnerForm from '../Partner/EditPartnerForm';
import NumericField from '../../components/ActiveForm/NumericField';
import ReactHTMLTableToExcel from '../../components/react-html-table-to-excel/src/ReactHTMLTableToExcel';
import ReactExport from "../../components/react-export-excel/dist";
// import ReactExport from "../../components/react-data-export/dist"
// import ExcelFile from '../../components/react-export-excel/src/ExcelPlugin/components/ExcelFile';
// import ExcelSheet from '../../components/react-export-excel/src/ExcelPlugin/elements/ExcelSheet';
import DateInput from '../../components/ActiveForm/DateInput';

interface OwnProps extends RouteProps {}

interface StateProps {
 
};

interface DispatchProps {

}

type CashflowReportProps = OwnProps & StateProps & DispatchProps;

const CashflowReport: React.FC<CashflowReportProps> = ({location}) => {
  const ionRouterContext = useContext(IonRouterContext);
  var today = new Date();

  const initdate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

  const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const apipath = 'cashflow';
    const [params,setParams] = useState({
        DateFrom:initdate
        ,DateTo:initdate
        ,InventoryID:0
    })
    const [errors,setErrors] = useState(
        []
    );

    const [errordetails,setErrordetails] = useState<any>(
        []
    );
    const [ischanged,setIschanged]=useState(false);
    const [data,setData] = useState<any>();
    const [salesummary,setSalesummary] = useState<any>([]);
    const [saleitemsummary,setSaleitemsummary] = useState<any>([]);

    const [details,setDetails] = useState<any>([]);
    const [currencylist,setCurrencylist] = useState<any>([]);
    const [currency,setCurrency] = useState<any>([]);
    const [isReadonly, setIsReadOnly] = useState(false);

    const [showCompleteToast, setShowCompleteToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [showLoading, setShowLoading] = useState(false);
    const [showSearchItemModal, setShowSearchItemModal] = useState(false);
    const [showSearchParnerModal, setShowSearchPartnerModal] = useState(false);
    const [showViewParnerModal, setShowViewPartnerModal] = useState(false);
    const [showAddParnerModal, setShowAddPartnerModal] = useState(false);
    const [showEditParnerModal, setShowEditPartnerModal] = useState(false);

    const [myInventory, setMyInventory] = useState<any>([]);
    const [currentInventory,setCurrentInventory] = useState<any>();
    const [showAlert1, setShowAlert1] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertHeader, setAlertHeader] = useState("Warning");
    const [alertMessage, setAlertMessage] = useState("Warning");
    const [alertButtons, setAlertButtons] = useState<any>(['Ok']);
    const [selectdate,setSelectdate]= useState('today');
    const [iscustomdate,setIscustomdate]=useState(false);
    const pageRef = useRef<HTMLElement>(null);
    const [filename,setFilename] = useState("");
    const ionRefresherRef = useRef<HTMLIonRefresherElement>(null);

    const handleChange = (e:any,name:string) => {
        const { value } = e.detail;
        
            if(name==="date"){
                if(selectdate!==value){
                loaddate(value);
                }
            }
            
            else{
                setParams({
                    ...params,
                    [name]: value
                });
            }

            if(name ==="InventoryID"){
                const inventory = myInventory.find((f:any)=>f.InventoryID === value);
                setCurrentInventory(inventory);
            }
            setIschanged(true);
            
        
    };

    const handleChangeChecked = (e:any,name:string) => {
        const { checked } = e.detail;
        if(data[name]!==checked){
            setData({
                ...data,
                [name]: checked
            });
        }
        setIschanged(true);
        // setChecked(checked);
    };

    useEffect(() => {
        if(location){
            if(location.pathname === "/report/"+"cashflow"){
           
                loadinventory();
             
            }
        }
        // loaddata();
        // eslint-disable-next-line
      }, [location]);
    

      const loaddate=(code:any)=>{
        var date = new Date();
        var datefrom = new Date(date.getFullYear(), date.getMonth(), 1);
        var dateto = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
       
        switch(code){
            case 'today':
                 datefrom = date;
                 dateto = date;
                 setIscustomdate(false);

                break;
            case 'yesterday':
                
                 datefrom = new Date(date.getFullYear(), date.getMonth(),date.getDate()-1);
                 dateto = new Date(date.getFullYear(), date.getMonth(),date.getDate()-1);
                 setIscustomdate(false);

                break;
            case 'this week':

                 datefrom = new Date(date.setDate(diff));
                 dateto = new Date(datefrom.getFullYear(), datefrom.getMonth(),datefrom.getDate()+7);
                 setIscustomdate(false);

                break;
           
            case 'this month':
                datefrom = new Date(date.getFullYear(), date.getMonth(), 1);
                dateto = new Date(date.getFullYear(), date.getMonth()+1,0);
                setIscustomdate(false);

                break;
           
            case 'custom':
                setIscustomdate(true);
                break;
            default:
                break;

        }

       
        const datefromstring = datefrom.getFullYear() + '-' + (datefrom.getMonth() + 1) + '-' + datefrom.getDate();
        const datetostring = dateto.getFullYear() + '-' + (dateto.getMonth() + 1) + '-' + dateto.getDate();
        
        setSelectdate(code);
        setParams({...params
            ,DateFrom:datefromstring
            ,DateTo:datetostring});
        
      }
    const loaddata=async()=>{
      setShowLoading(true);
      var result:any = await API.insert("report/cashflow",null).catch(e=>errorhandler(e));
    
      if(result){
          setToastMessage("load complete");
       
      }
      else{

      }
   
    if(ionRefresherRef.current ){
        ionRefresherRef.current!.complete();
        }
      setShowCompleteToast(true);
      setShowLoading(false);
    }

    const loadinventory = async()=>{
        var inventories:any = await API.view("user/myinventory").catch(e=>errorhandler(e));
       
        if(inventories&&inventories.length>0){
            inventories = inventories.sort((a:any,b:any)=>a.Name>b.Name?1:-1);
            inventories.unshift({id:0,Name:"All Inventory",Address:"All Inventory",Description:"All Inventory",Active:true});
            setMyInventory(inventories);
            setParams({...params,InventoryID:inventories[0].id});
            setCurrentInventory(inventories[0]);
        }
      }

      const generatefilename = async(params:any) =>{
          var filename = "report";
          switch(selectdate){
            case "today":
            case "yesterday":
                filename = "_"+currentInventory.Name +"_("+params.DateFrom+")";
                break;
            default:
                filename = "_"+currentInventory.Name +"_("+params.DateFrom+")_("+params.DateTo+")";
                break;
            }

            setFilename(filename);
      }
      const generatereport = async()=>{
        setShowLoading(true);
        var lparams = params;
        var datef = new Date(lparams.DateFrom);
        var datefrom = datef;
        const datefromstring = datefrom.getFullYear() + '-' + (datefrom.getMonth() + 1) + '-' + datefrom.getDate();
        
        var datet = new Date(lparams.DateTo);
        var dateto = datet;
        const datetostring = dateto.getFullYear() + '-' + (dateto.getMonth() + 1) + '-' + dateto.getDate();

        lparams={...lparams,DateFrom:datefromstring,DateTo:datetostring}        

        await setParams(lparams);
        await generatefilename(lparams);
        var dataraw:any = await API.insert("report/cashflow",lparams).catch(e=>errorhandler(e));
        if(dataraw){
            // setData(data);
            var data:any =[];
            dataraw.map((d:any)=>{
                if(data[d.CashFlowAccountID]){
                    
                }
                else{
                    data[d.CashFlowAccountID]={...d.cashflow,SALE:0,RECEIVABLE:0,INCOME:0,EXPENSE:0,Total:0}
                }

                switch(d.PaymentType){
                    case 'SALE':
                        data[d.CashFlowAccountID]={
                            ...data[d.CashFlowAccountID]
                            ,SALE:parseFloat(data[d.CashFlowAccountID].SALE)+parseFloat(d.Debit)
                            ,Total:parseFloat(data[d.CashFlowAccountID].Total)+parseFloat(d.Debit)
                        }
                        break;
                    case 'RECEIVABLE':
                        data[d.CashFlowAccountID]={
                            ...data[d.CashFlowAccountID]
                            ,RECEIVABLE:parseFloat(data[d.CashFlowAccountID].RECEIVABLE)+parseFloat(d.Debit)
                            ,Total:parseFloat(data[d.CashFlowAccountID].Total)+parseFloat(d.Debit)
                        }
                        break;
                    case 'INCOME':
                        data[d.CashFlowAccountID]={
                            ...data[d.CashFlowAccountID]
                            ,INCOME:parseFloat(data[d.CashFlowAccountID].INCOME)+parseFloat(d.Debit)
                            ,Total:parseFloat(data[d.CashFlowAccountID].Total)+parseFloat(d.Debit)
                        }
                        break;
                    case 'EXPENSE':
                        data[d.CashFlowAccountID]={
                            ...data[d.CashFlowAccountID]
                            ,EXPENSE:parseFloat(data[d.CashFlowAccountID].EXPENSE)+parseFloat(d.Debit)
                            ,Total:parseFloat(data[d.CashFlowAccountID].Total)+parseFloat(d.Debit)
                        }
                        break;
                }
            })

            setData(data);
        }
        else{
           
            setData([]);
            setAlertMessage("no data");
            setShowAlert(true);
        }
        setShowLoading(false);
      }
    const errorhandler = (err:any) =>{
      setToastMessage(err.message);
      if(err.response){
          if(err.response.status==422){
              
          }
      }
      else{
          console.log("errorhandler",err.message);
      }
    }
    
    function getErrorMessage(field:string) {
        if(!Array.isArray(errors)){
            return ;
        }
        else{
        return (
            <div className="validation-errors"> 
                {errors.filter((error:any) => error.field === field).map((filterederror:any) => (
                <div key={field} className="error-message"> 
                <IonIcon slot="icon-only" icon={informationCircleOutline}></IonIcon>
                    {filterederror.message}
                    
                </div>
                
                ))}
            </div>
            
            );
        }
    }
  return (
    <IonPage id="form-page">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{"CASHFLOW REPORT"}</IonTitle>
          <IonButtons slot="end">
          
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      
      <IonContent>
      <IonLoading
          // cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Please wait...'}
          // duration={5000}
        />
        {/* <IonRefresher slot="fixed" ref={ionRefresherRef} onIonRefresh={loaddata}>
          <IonRefresherContent />
        </IonRefresher> */}

        <IonToast
          isOpen={showCompleteToast}
          message={toastMessage}
          duration={2000}
          onDidDismiss={() => setShowCompleteToast(false)}
        />

        <IonCard className="field-card">
        
        <IonCardContent>
        <IonList lines="none">
         <IonItem>
            
            <IonLabel position="fixed" color="primary">Date</IonLabel>
            <Selectfield name={"date"} value={selectdate} 
                    option={{datas:[
                                    {id:'today',Name:'Today'}
                                    ,{id:'yesterday',Name:'Yesterday'}
                                    ,{id:'this week',Name:'This Week'}
                                    ,{id:'this month',Name:'This Month'}
                                    ,{id:'custom',Name:'Custom'}
                                    ]
                                ,label:"Name",value:"id"}} 
                    dataChanged={e=>handleChange(e,"date")}/>
                    
        </IonItem>
        {iscustomdate&&
            <IonItem>
                <IonLabel position="fixed" color="primary">
                Date From
                </IonLabel>
                <DateInput disabled={!iscustomdate} displayFormat="DD MMM YYYY" placeholder="Select Date" value={params.DateFrom} onIonChange={e => handleChange(e,"DateFrom")}></DateInput>
            </IonItem>
        }
        {iscustomdate&&
            <IonItem>
                <IonLabel position="fixed" color="primary">
                Date To
                </IonLabel>
                <DateInput  displayFormat="DD MMM YYYY" placeholder="Select Date" value={params.DateTo} onIonChange={e => handleChange(e,"DateTo")}></DateInput>
            </IonItem>
        }

        <IonItem>
            
            <IonLabel position="fixed" color="primary">Inventory</IonLabel>
            
            {myInventory.length>0&&
                    <Selectfield name={"InventoryID"} value={params["InventoryID"]} option={{datas:myInventory,label:"Name",value:"id"}} dataChanged={e=>handleChange(e,"InventoryID")}/>
                    }
        </IonItem>
        <IonItem>
        <IonButton title={"Generate Report"} onClick={() => generatereport() }>
              <IonIcon icon={newspaperOutline}></IonIcon> Generate
            </IonButton>
        </IonItem>
        </IonList>
{data&&
<IonCardContent>
        <div className = "xlstable">
                <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button"
                    table="report-cashflow"
                    filename={"cashflow_"+filename}
                    sheet={"cashflow_"+filename}
                    buttonText="download"/>
                <table id="report-cashflow">
                <tr>
                        <th>Report</th>
                        <th>Inventory</th>
                        <th>DateFrom</th>
                        <th>DateTo</th>
                        
                        
                </tr>
                    <tr>
                        <td>{"CASHFLOW"}</td>
                        <td>{currentInventory.Name}</td>
                        <td>{params.DateFrom}</td>
                        <td>{params.DateTo}</td>
                        
                        
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        
                        
                    </tr>
                    <tr>
                        <th className="topfixed">Name</th>
                        <th className="topfixed">AccountName</th>
                        <th className="topfixed">AccountNo</th>
                        <th className="topfixed">SALE</th>
                        <th className="topfixed">RECEIVABLE</th>
                        <th className="topfixed">INCOME</th>
                        <th className="topfixed">EXPENSE</th>
                        <th className="topfixed">Total</th>
                    </tr>
                    {data.map((element:any) => {
                        return <tr>
                            <td>{element.Name}</td>
                            <td>{element.AccountName}</td>
                            <td>{element.AccountNumber}</td>
                            <td>{element.SALE}</td>
                            <td>{element.RECEIVABLE}</td>
                            <td>{element.INCOME}</td>
                            <td>{element.EXPENSE}</td>
                            <td>{element.Total}</td>
                            </tr>
                    })}                        
                        <tr>
                        <td></td>
                        <td></td>
                        </tr>
                        <tr>
                        <th>GenerateDate</th>
                        <td>{new Date().toString()}</td>
                        </tr>
                </table>
                
            </div>
            </IonCardContent>
}


        </IonCardContent>
      </IonCard>
         
      </IonContent>
      
      <IonAlert
          isOpen={showAlert}
          onDidDismiss={() => setShowAlert(false)}
          header={alertHeader}
          message={alertMessage}
          buttons={alertButtons}
        />
    </IonPage>
  );
};

export default connect<OwnProps, StateProps, DispatchProps>({
  mapStateToProps: (state, OwnProps) => ({
  }),
  mapDispatchToProps: {
  },
  component: React.memo(CashflowReport)
})